<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowHaeConversionRate',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
          this.getYtdByField(yearObj, 'number_ha_appointments', throughMonth),
          0);
      },
    },
  };
</script>
